import { makeStyles } from 'tss-react/mui'
import { lato } from '@styles/fonts'
import { nunito_sans } from '@styles/fonts'
import BgImage from 'src/assets/images/report/reportNow.jpg'

const useStyles = makeStyles()((theme) => ({
  outerContainer: {
    height: 'auto',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    borderRadius:'20px',
    overflow:'hidden'
  },

  innerContainer: {
    maxWidth: theme.maxWidth,
    // padding: theme.spacing(0, 20, 20),
    // [theme.breakpoints.down('md')]: {
    //   padding: theme.spacing(0, 4, 15),
    // },
  },
  bgImg: {
    backgroundImage: `url(${BgImage?.src})`,
    backgroundRepeat: 'no-repeat',
    borderRadius: '60px',
    backgroundPosition: 'center',
    padding: theme.spacing(15, 30),
    backgroundSize: '100% 100%',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(15, 5, 4),
      borderRadius: '40px',
    },
  },
  header: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'italic',
    fontWeight: 900,
    fontSize: '72px',
    textAlign: 'center',
    lineHeight: '64px',
    letterSpacing: '-0.05em',

    textTransform: 'uppercase',
    color: theme.custom.blackColor,
    [theme.breakpoints.down('md')]: {
      fontSize: '48px',
      lineHeight: '46px',
    },
  },
  subHeader: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '32px',
    textAlign: 'center',
    lineHeight: '44px',
    textTransform: 'uppercase',
    color: theme.custom.blackColor,
    [theme.breakpoints.down('md')]: {
      fontSize: '18px',
      lineHeight: '24px',
    },
  },
  desc: {
    fontFamily: lato.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '20px',
    textAlign: 'center',
    lineHeight: '24px',
    padding: theme.spacing(6, 0, 0),
    margin: 'auto',
    opacity: '.7',
    width: '70%',
    color: theme.custom.blackColor,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      fontSize: '16px',
      textAlign: 'center',
      lineHeight: '19px',
    },
  },
  img: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      width: '20px',
      marginBottom: theme.spacing(2),
    },
  },
  logoWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(3),
    margin: theme.spacing(5, 0, 10),

    p: {
      fontFamily: lato.style.fontFamily,
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '16px',
      lineHeight: '19px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
      },
    },
  },
  pressEnter: {
    fontFamily: lato.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 400,
    margin: theme.spacing(5, 0, 0),
    fontSize: '18px',
    lineHeight: '22px',
    opacity: '.7',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  learnMoreBtn: {
    background: 'black',
    color: 'white',
    textAlign: 'center',
    '&:hover': {
      background: 'black',
      color: 'white',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flex: 1,
    },
  },
  btnWrapper: {
    width: 'fit-content',
    margin: 'auto',
    marginTop: theme.spacing(8),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  zenBg: {
    backgroundImage: `url('')`,
    border: '1px solid black',
  },
}))

export default useStyles
